<template>
  <div>
    <div class="p-relative header-image pb-5"></div>

    <b-container class="custom-container mt-5">
      <b-row>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <b-col cols="12" sm="6">
                <h4 class="font-weight-bold pt-4 mb-4 align-middle">
                  Requests
                </h4>
              </b-col>
              <b-col cols="12" sm="6"></b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-card
                  border-variant="light"
                  bg-variant="light"
                  body-class="px-0 py-0"
                >
                  <!-- <recent-request-file-list /> -->
                  <b-tabs
                    v-model="tabIndex"
                    class="request-tab"
                    active-nav-item-class="font-weight-bolder text-primary active"
                  >
                    <template #tabs-end class="float-right">
                      <b-button
                        @click="showFilter = true"
                        variant="outline-secondary"
                        class="py-2 ml-sm-auto my-auto float-sm-left"
                      >
                        <b-icon icon="plus" class="mr-1"></b-icon> Filter
                      </b-button>
                    </template>

                    <b-tab
                      :active="isTradieUser && tabIndex === 0"
                      :disabled="tabsLoading && tabIndex !== 0"
                    >
                      <template #title>
                        Assigned To You
                        <div class="line"></div>
                      </template>
                      <recent-request-file-list
                        :tabIndex="tabIndex"
                        @loading="setLoading"
                      />
                    </b-tab>
                    <b-tab
                      v-if="!isTradieUser"
                      :active="!isTradieUser && tabIndex === 1"
                      :disabled="tabsLoading && tabIndex !== 1"
                    >
                      <template #title>
                        Created By You
                        <div class="line"></div>
                      </template>
                      <recent-request-file-list
                        :tabIndex="tabIndex"
                        @loading="setLoading"
                      />
                    </b-tab>
                  </b-tabs>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>

    <requests-filter-modal
      :showRequestsFilter="showFilter"
      @closeRequestsFilterModal="closeFilter"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import RecentRequestFileList from '@/components/lists/RecentRequestFileList'
import RequestsFilterModal from '@/components/modals/RequestsFilterModal'

export default {
  components: {
    // SearchBar,
    RecentRequestFileList,
    RequestsFilterModal
  },

  data() {
    return {
      showFilter: false,
      tabIndex: 0,
      tabsLoading: false
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),

    isTradieUser() {
      return this.user ? this.user.user_type === 'tradie' : false
    }
  },

  mounted() {
    if (this.user && !this.isTradieUser) {
      this.tabIndex = 1
    }
  },

  methods: {
    closeFilter() {
      this.showFilter = false
    },
    setLoading(loading) {
      this.tabsLoading = loading
    }
  }
}
</script>

<style lang="scss" scoped>
.header-image {
  // top: 88px;
  // height: 280px;
  background: transparent linear-gradient(130deg, #006cff 0%, #00429d 100%) 0%
    0% no-repeat padding-box;
}

.header-text {
  // top: 136px;
  margin-top: 88px;
  font-size: 35px;
}

/deep/ nav.center-screen {
  margin-top: 0;
}

/deep/ .collapsed {
  .when-open {
    display: none;
  }
}

/deep/ .not-collapsed {
  .when-closed {
    display: none;
  }
}

/deep/ .request-tab {
  a {
    padding: 24px 16px 0 !important;
    margin-bottom: 0px !important;

    & > .line {
      border-bottom: 6px solid transparent;
      border-top-left-radius: 25px;
      border-top-right-radius: 25px;
      margin: 24px 0 0;
    }

    &.active > .line {
      border-bottom: 8px solid #007bff !important;
    }
  }
}
</style>
